import { generatePublicChat } from './layout/chat'

export function chatHandler() {
  generatePublicChat()
}

chatHandler()
